

// set the dollar or rupe based on country to the string
export const getPrice = (inIndia, price, attachedString)=> {
 return   inIndia ? `₹${price + attachedString}` : `$${price + attachedString}`
}